import { createTheme, ThemeProvider } from "@mui/material/styles";
import * as Auth from "@aws-amplify/auth";
import axios from "axios";
import React from "react";
import "./App.scss";
// import { createBrowserHistory as history } from "history";
import { AuthProvider } from "./hooks/useAuth";
import { NotificationProvider } from "./hooks/use-notification";
import Router from "./Router";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { loadUserAppProfile } from "./hooks/loadProfile"
import { SearchProvider } from "./hooks/useSearch";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

var runAsUser = "";

var google_recaptcha_key = process.env.REACT_APP_RECAPTCHA;
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use(
  async (config) => {
    // Auth not required for pre-qual call
    if (!config.url.startsWith("apply/") && !config.url.startsWith("order/")) {
      const session = await Auth.fetchAuthSession();
      if (session) {
        config.headers.Authorization = `Bearer ${session.tokens.idToken}`;
        console.log(runAsUser);
        if (runAsUser && runAsUser.length > 0) {
          config.headers["override-email"] = runAsUser;
        }
      }
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    console.log(error);
    return Promise.reject(error);
  }
);

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
      contrastText: "white",
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    title: {
      color: "",
    },
    h6:{
  

    },
    subtitle3: {
      color: "blue",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;300;400;700&display=swap');
      `,
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <GoogleReCaptchaProvider reCaptchaKey={google_recaptcha_key}>
        <AuthProvider loadUserAppProfile={loadUserAppProfile}>
          <SearchProvider>
            <React.Suspense fallback={<div> Loading... </div>}>
              <NotificationProvider>
                <Router />
              </NotificationProvider>
            </React.Suspense>
          </SearchProvider>
        </AuthProvider>
      </GoogleReCaptchaProvider>
    </ThemeProvider>
  );
};

export default App;
